// extracted by mini-css-extract-plugin
module.exports = {"Background":"WhyChoose_Background__euXrD","Grid":"WhyChoose_Grid__bxac5","Content":"WhyChoose_Content__ULgjt","Header":"WhyChoose_Header__Pzrf7","Button":"WhyChoose_Button__D8Cqz"};